import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import helpersNumbers from "../../../helpers/numbers";
import helperSpinner from "../../../helpers/spinner";
import TitleBar from "../../partials/content/TitleBar";
import Pagination from "../../partials/content/Pagination";

function Invoices() {
  const [allInvoices, setAllInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);

  useEffect(() => {
    getInvoices();
  }, []);

  useEffect(() => {
    getInvoices();
  }, [currentPage, countItemPerPage]);

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getInvoices = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllInvoice = await sendRequestGetAllInvoice();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetAllInvoice) {
      return;
    }

    setAllInvoices(resultSendRequestGetAllInvoice.payments);
    setCountPage(resultSendRequestGetAllInvoice.count_page);
  };

  const generateDoesNotHaveAnyInvoices = () => {
    return (
      <>
        <div class="d-flex flex-column flex-md-row">
          <div class="text-center text-md-right">
            <img
              src="/assets/img/do-not-have-invoices.svg"
              className="img-fluid w-75"
            />
          </div>
          <div class="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
            <p>
              لیست فاکتور‌ها و پیش‌فاکتور‌های شما در این صفحه نمایش داده میشود.
            </p>
            <p>شما تاکنون فعالیتی نداشته اید و تاریخچه مالی شما خالی است.</p>
            <span>
              <Link to="/finance/charge" className="btn btn-success ">
                <span className="pl-2">
                  <i className="fa fa-plus"></i>
                </span>
                <span>افزایش اعتبار</span>
              </Link>
            </span>
          </div>
        </div>
      </>
    );
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateTagAllInvoices = () => {
    return (
      <>
        <div className="alert alert-warning ">
          <p>
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p>
                لیست فاکتور‌ها و پیش‌فاکتور‌های شما در این صفحه نمایش داده
                میشود.
              </p>
            </li>
            <li>
              <p>
                در این بخش شما میتوانید از بخش مشاهده پیش فاکتور درخواست فاکتور
                رسمی نمایید.
              </p>
            </li>
          </ul>
        </div>
        <div className="table-responsive pt-3">
          <table className="table table-hilite tbl-td-white-space table-hover mb-0">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره فاکتور</td>
                <td>مبلغ پرداخت (تومان)</td>
                <td>کد پیگیری</td>
                <td>مبلغ شارژ (تومان)</td>
                <td>تاریخ پرداخت</td>
                <td>فاکتور رسمی</td>
                <td>مشاهده پیش فاکتور</td>
              </tr>
            </thead>
            <tbody>{generateItemsInvoice(allInvoices)}</tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const generateItemsInvoice = () => {
    return allInvoices.map((invoice, index) => {
      return (
        <tr key={index}>
          <td>{helpersNumbers.toPersianNum(index + 1)}</td>
          <td>{helpersNumbers.toPersianNum(invoice.id)}</td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(invoice.amount)
            )}
          </td>
          <td>{invoice.reference}</td>
          <td className="letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(
                Math.floor(
                  (invoice.amount * 100) /
                    (100 +
                      parseInt(process.env.REACT_APP_TAX_PERCENT_AMOUNT_CHARGE))
                )
              )
            )}
          </td>
          <td dir="ltr">{helpersNumbers.toPersianNum(invoice.paid_at)}</td>
          <td>
            {invoice.send_invoice ? (
              <span className="badge badge-success">صادر شده</span>
            ) : (
              <span className="badge badge-danger">صادر نشده</span>
            )}
          </td>
          <td>
            <Link to={`/finance/official/${invoice.id}`}>
              <span className="btn btn-info">
                <i className="fa fa-eye"></i>
              </span>
            </Link>
          </td>
        </tr>
      );
    });
  };

  const sendRequestGetAllInvoice = async () => {
    const headersRequest = getHeaderForRequest();
    let allInvoices;
    try {
      allInvoices = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/payment?page=${currentPage}&number=${countItemPerPage}`,
        headersRequest
      );
    } catch (error) {
      return false;
    }
    return allInvoices.data.data;
  };

  return (
    <>
      <Sidebar openItem="all-finance" activeItem="invoices-finance" />

      <div className="content-wrapper">
        <TitleBar title="فاکتورها و پیش فاکتورها" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {allInvoices.length == 0
                ? generateDoesNotHaveAnyInvoices()
                : generateTagAllInvoices()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Invoices;
